import React from 'react';
import { Breadcrumb, Button, Typography } from 'antd';
import { HomeOutlined, PlusOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Title, Text } = Typography;

type Props = {
  onAddLead: () => void;
};

export const LeadsPageHeader: React.FC<Props> = ({ onAddLead }) => (
  <div style={{ marginBottom: 20 }}>
    <Breadcrumb
      style={{ marginBottom: 8 }}
      items={[
        { title: <Link to="/"><HomeOutlined /></Link> },
        { title: <Link to="/growth/leads">Growth & Revenue</Link> },
        { title: 'Leads' },
      ]}
    />
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        gap: 12,
      }}
    >
      <div>
        <Title level={2} style={{ margin: 0 }}>
          Leads Management
        </Title>
        <Text type="secondary">Track and qualify prospects across your sales pipeline.</Text>
      </div>
      <Button type="primary" size="large" icon={<PlusOutlined />} onClick={onAddLead}>
        Add Lead
      </Button>
    </div>
  </div>
);
